import React, { Component } from 'react';
import './PolicyStep.css';
import FaCalendar from 'react-icons/lib/fa/calendar';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import CategoryItemIcon from '../../../../components/Calculator-board/Category-item/Category-item-icon/CategoryItemIcon';
import SelectCarCard from '../../../../components/Select-car-card/SelectCarCard';
import SelectedCarCardMobile from '../../../../components/Select-Car-Card-Mobile/SelectCarCardMobile';
import classnames from 'classnames';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import InputDatepicker from '../../../../components/Input-datepicker/InputDatepicker';
import SelectedCarCardSmMobile from '../../../../components/Select-Car-Card-Sm-Mobile/SelectCarCardSmMobile'
import * as moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import PolicyRegScrollbar from '../../../../components/PolicyRegScrollbar/PolicyRegScrollbar'
import FaClose from "react-icons/lib/fa/close"

const validate = values => {
    const errors = {};
    if (!values.startDate) {
        errors.startDate = 'сhooseTheDate';
    }
    return errors;
};

const intialValues = {
    vehicleCategoryId: JSON.parse(localStorage.getItem('vehicleCategoryId')) || 8,
};

class PolicyStep extends Component {
    constructor() {
        super();
        this.state = {
            limitationBeforeProductRealization: '',
            minDate: '',
            maxDate: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.fromHome && nextProps.categories.length) {
            let category = nextProps.categories[0];
            if(JSON.parse(localStorage.getItem('vehicleCategoryId'))) {
                category = nextProps.categories.find(cat => cat.id === JSON.parse(localStorage.getItem('vehicleCategoryId')))
            }
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'vehicleCategoryId',
                    category.id
                )
            );
            this.props.dispatch(
                change('CreatePolicyForm', 'products', category.products)
            );
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'issueDateDiff',
                    category.products[0].period
                )
            );
            this.props.dispatch(change('CreatePolicyForm', 'fromHome', true));
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'vehicleCategoryName',
                    category.number
                )
            );
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'premium',
                    category.products[0].price
                )
            );
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'dayType',
                    category.products[0].periodType
                )
            );
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'issueDate',
                    category.products[0].productId
                )
            );
            this.setState({
                limitationBeforeProductRealization: category.products[0].limitationBeforeProductRealization,
                minDate: category.products[0].minDate,
                maxDate: category.products[0].maxDate
            })
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    onStartDateChange = value => {
        if (this.props.issueDateDiff && value && this.props.issueDateDiff !== 1) {
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'endDate',
                    moment(value).add(this.props.issueDateDiff - 1, 'd')
                )
            );
        }

        if (this.props.issueDateDiff && value && this.props.issueDateDiff === 1) {
            this.props.dispatch(
                change(
                    'CreatePolicyForm',
                    'endDate',
                    moment(value).add(this.props.issueDateDiff, 'y').subtract(1, "days")
                )
            );
        }
    };


    onCategoryChange = value => {
        this.props.categories.forEach(item => {
            if (item.id === value.id) {
                localStorage.setItem('vehicleCategoryId', item.id);
                this.props.dispatch(
                    change('CreatePolicyForm', 'vehicleCategoryId', item.id)
                );
                this.props.dispatch(
                    change('CreatePolicyForm', 'vehicleCategoryName', item.number)
                );
                this.props.dispatch(
                    change('CreatePolicyForm', 'products', item.products)
                );
                this.props.dispatch(
                    change('CreatePolicyForm', 'issueDateDiff', item.products[0].period)
                );
                this.props.dispatch(
                    change('CreatePolicyForm', 'premium', item.products[0].price)
                );
                this.props.dispatch(
                    change('CreatePolicyForm', 'dayType', item.products[0].periodType)
                );
                this.props.dispatch(
                    change('CreatePolicyForm', 'issueDate', item.products[0].productId)
                );
                this.onPeriodChange(item.products[0])
            }
        });
    };

    onPeriodChange = item => {
        this.props.dispatch(
            change('CreatePolicyForm', 'issueDateDiff', item.period)
        );
        this.props.dispatch(
            change('CreatePolicyForm', 'issueDate', item.productId)
        );
        this.props.dispatch(change('CreatePolicyForm', 'dayType', item.periodType));
        this.props.dispatch(change('CreatePolicyForm', 'premium', item.price));
        setTimeout(() => {
            this.onStartDateChange(this.props.startDate);
        }, 0);

        this.setState({
            limitationBeforeProductRealization: item.limitationBeforeProductRealization,
            minDate: item.minDate,
            maxDate: item.maxDate
        })
    };

    render() {
        const { handleSubmit, translate } = this.props;
        return (
            <div className="policy-registration-container">
                <div className="policy-create-card" id="policy-create-card">
                    <PolicyRegScrollbar numb={1} />
                    {/* </div>  */}
                    <SelectedCarCardMobile />
                    <SelectedCarCardSmMobile />
                    <div className="policy-create-card-categories">
                        {this.props.categories.map((item, index) => {
                            return (
                                <div
                                    className={classnames('policy-create-card-category-item', {
                                        'policy-create-card-category-item-selected':
                                            item.id === this.props.vehicleCategoryId,
                                    })}
                                    key={index}
                                    onClick={() => this.onCategoryChange(item)}
                                >
                                    <CategoryItemIcon iconName={item.number} width={70} />
                                    <div>{translate(item.number)}</div>
                                </div>
                            );
                        })}
                    </div>
                    {this.props.products && (
                        <div className="policy-create-card-days">
                            {this.props.products.map((item, index) => {
                                return (
                                    <div
                                        className={classnames('policy-create-card-day-item', {
                                            'policy-create-card-day-item-selected':
                                                item.period === this.props.issueDateDiff,
                                        })}
                                        key={index}
                                        onClick={() => {
                                            this.onPeriodChange(item);
                                        }}
                                    >
                                        <span>{item.period}</span>
                                        <span>{translate(item.periodType)}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    <form onSubmit={handleSubmit}>
                        <div className="policy-create-card-start-day">
                            <p className="policy-create-card-days-label">
                                {translate('enterPolicyStartDate')}</p>
                            <div className="policy-create-card-start-day-input">
                                <Field
                                    name="startDate"
                                    labelName={'startDate'}
                                    onChange={(event, value) =>
                                        this.onStartDateChange(event, value)
                                    }
                                    component={InputDatepicker}
                                    id={12}
                                    placeholder={''}
                                    type="text"
                                    endDate={this.state.limitationBeforeProductRealization}
                                    minDate={this.state.minDate}
                                    maxDate={this.state.maxDate}
                                />

                            </div>
                        </div>
                        <div className="policy-create-card-end-day">
                            {/* <p className="policy-create-card-days-label">{translate('endDate')}</p> */}
                            <div className="policy-create-card-start-day-input">
                                <Field
                                    name="endDate"
                                    labelName={'endDate'}
                                    component={InputDatepicker}
                                    id={11}
                                    placeholder={''}
                                    type="text"
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="container step-btn-content">
                            <div className="step-btn-content-text">
                                {translate('pleaceKeepInMind')}
                            </div>
                            <button className="next-btn" type="submit">
                                {translate('next')}
                            </button>
                        </div>
                    </form>
                </div>
                <SelectCarCard />
            </div>
        );
    }
}
PolicyStep = reduxForm({
    intialValues,
    validate,
    destroyOnUnmount: false,
    form: 'CreatePolicyForm', // a unique identifier for this form
})(PolicyStep);
const selector = formValueSelector('CreatePolicyForm');

const mapStateToProps = state => ({
    categories: state.categories,
    vehicleCategoryId: selector(state, 'vehicleCategoryId'),
    fromHome: selector(state, 'fromHome'),
    issueDate: selector(state, 'issueDate'),
    startDate: selector(state, 'startDate'),
    issueDateDiff: selector(state, 'issueDateDiff'),
    vehicleManufacturerNumber: selector(state, 'vehicleManufacturerNumber'),
    vehicleCategoryName: selector(state, 'vehicleCategoryName'),
    dayType: selector(state, 'dayType'),
    products: selector(state, 'products'),
    translate: getTranslate(state.locale),
    limitationBeforeProductRealization: selector(state, 'limitationBeforeProductRealization'),
    minDate: selector(state,'minDate'),
    maxDate: selector(state,'maxDate'),
});
export default connect(mapStateToProps)(PolicyStep);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/steps/PolicyStep/PolicyStep.js